module.exports = __webpack_public_path__ + "static/media/how-we-can-adapt-plants-to-save-our-planet.446b6f4c.jpg";